import { convertParams } from 'src/utils/utils'
import axios from '../axios'
import { SETTINGROUTES } from 'src/router/Api'
export const getListSetting = async (params) => {
	return await axios.get(SETTINGROUTES.name, {
		params: convertParams(params),
	})
}
export const getListSettingPublic = async (params) => {
	return await axios.get(SETTINGROUTES.name, {
		params: convertParams(params),
		skipAuth: true,
	} as any)
}
export const getOneSetting = async (id, params) => {
	return await axios.get(`${SETTINGROUTES.name}/${id}`, {
		params: convertParams(params),
	})
}

export const updateSetting = async (id: string, body: any) => {
	return await axios.put(`${SETTINGROUTES.name}/${id}`, body)
}

export const runSystemScript = async (payload: any) => {
	return await axios.post(`${SETTINGROUTES.name}/run-script`, payload)
}

export const getDatabaseStorage = async () => {
	return await axios.get(`${SETTINGROUTES.name}/database-storage`)
}

// UD-564: USD to VND rate used to show Course prices in dollars in the app.
export const getUsdRate = async () => {
	return await axios.get(SETTINGROUTES.exchangeRate)
}

export const updateUsdRate = async (usdVndRate: number) => {
	return await axios.put(SETTINGROUTES.exchangeRate, {
		usd_vnd_rate: usdVndRate,
	})
}
